import * as React from 'react';
import { ICommand } from '../../../models/commands/ICommand';
import { Facet } from '../../../models/Facet';
import CommandStrings from '../Commands.resx';
import { HideWithSelection } from '../../selectionVisibility/SelectionVisibility';
import { UploadFileAction } from '../../actions/upload/UploadFileAction';

export const uploadFileCommand: ICommand = {
  key: new Facet('uploadFile').id,
  automationId: 'uploadFileCommand',
  name: CommandStrings.UploadFile,
  action: <HideWithSelection><UploadFileAction /></HideWithSelection>
};
